import { Component, Input, ViewChild } from '@angular/core';

import { MdSidenav, MdSidenavToggleResult } from '@angular/material';
export class TdLayoutManageListComponent {

   _sideNav: MdSidenav;
/**
 * mode?: 'side', 'push' or 'over'
 * 
 * The mode or styling of the sidenav.
 * Defaults to "side".
 * See "MdSidenav" documentation for more info.
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 */
mode: 'side' | 'push' | 'over' = 'side';
/**
 * opened?: boolean
 * 
 * Whether or not the sidenav is opened. Use this binding to open/close the sidenav.
 * Defaults to "true".
 * 
 * See "MdSidenav" documentation for more info.
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 */
opened: boolean = true;
/**
 * sidenavWidth?: string
 * 
 * Sets the "width" of the sidenav in either "px" or "%" ("%" is not well supported yet as stated in the layout docs)
 * Defaults to "257px".
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 */
sidenavWidth: string = '257px';
/**
 * Checks if `ESC` should close the sidenav
 * Should only close it for `push` and `over` modes
 * @return {?}
 */
get disableClose(): boolean {
    return this.mode === 'side';
  }
/**
 * Proxy toggle method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public toggle(): Promise<MdSidenavToggleResult> {
    return this._sideNav.toggle();
  }
/**
 * Proxy open method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public open(): Promise<MdSidenavToggleResult> {
    return this._sideNav.open();
  }
/**
 * Proxy close method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public close(): Promise<MdSidenavToggleResult> {
    return this._sideNav.close();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-layout-manage-list',
  styleUrls: ['./layout-manage-list.component.css' ],
  templateUrl: './layout-manage-list.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_sideNav': [{ type: ViewChild, args: [MdSidenav, ] },],
'mode': [{ type: Input, args: ['mode', ] },],
'opened': [{ type: Input, args: ['opened', ] },],
'sidenavWidth': [{ type: Input, args: ['sidenavWidth', ] },],
};
}

function TdLayoutManageListComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdLayoutManageListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdLayoutManageListComponent.ctorParameters;
/** @type {?} */
TdLayoutManageListComponent.propDecorators;
/** @type {?} */
TdLayoutManageListComponent.prototype._sideNav;
/**
 * mode?: 'side', 'push' or 'over'
 * 
 * The mode or styling of the sidenav.
 * Defaults to "side".
 * See "MdSidenav" documentation for more info.
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 * @type {?}
 */
TdLayoutManageListComponent.prototype.mode;
/**
 * opened?: boolean
 * 
 * Whether or not the sidenav is opened. Use this binding to open/close the sidenav.
 * Defaults to "true".
 * 
 * See "MdSidenav" documentation for more info.
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 * @type {?}
 */
TdLayoutManageListComponent.prototype.opened;
/**
 * sidenavWidth?: string
 * 
 * Sets the "width" of the sidenav in either "px" or "%" ("%" is not well supported yet as stated in the layout docs)
 * Defaults to "257px".
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 * @type {?}
 */
TdLayoutManageListComponent.prototype.sidenavWidth;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
